import { useQuery } from '@apollo/client'
import { LoggerErrorType } from '../data/logger'
import {
  PROJECT_BY_SURVEY_ID,
  ProjectData
} from '../modules/Project/Project.query'
import { captureApolloError } from '../utils/HelperFunctions'
import { useSurveyId } from './useSurveyId'

const useGetSurveyState = () => {
  const surveyId = useSurveyId()

  const { data: dataProject, loading } = useQuery<ProjectData>(
    PROJECT_BY_SURVEY_ID,
    {
      variables: {
        surveyId
      },
      context: { clientName: 'dashboard' },
      onError: (error) => {
        captureApolloError(
          LoggerErrorType.ApolloQuery,
          'projectBySurveyId',
          error
        )
      }
    }
  )

  // `projectBySurveyId` returns the project with ALL its surveys, so pick the
  // survey this route is about — surveys[0] is a different market on
  // multi-market projects.
  return {
    surveyState: dataProject?.project.surveys.find(
      (survey) => survey.surveyId === surveyId
    )?.state,
    loading
  }
}

export default useGetSurveyState
